var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKafkaDarkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160699",
    "data-name": "Group 160699",
    transform: "translate(-464 -320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160698",
    "data-name": "Group 160698",
    transform: "translate(288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160600",
    "data-name": "Group 160600",
    transform: "translate(177.11 320.912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160599",
    "data-name": "Group 160599",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    width: 15.533,
    height: 14.424,
    transform: "translate(0 1.006)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4528",
    "data-name": "Group 4528",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1334",
    "data-name": "Rectangle 1334",
    width: 15.533,
    height: 14.424,
    transform: "translate(0 1.006)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_198",
    transform: "translate(3.734)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    cx: 2.016,
    cy: 2.016,
    r: 2.016,
    transform: "translate(0)",
    fill: "none",
    stroke: "#165cf3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_198-2",
    "data-name": "Ellipse 198",
    cx: 1.512,
    cy: 1.512,
    r: 1.512,
    transform: "translate(0.504 0.504)",
    fill: "none",
    stroke: "#165cf3",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    cx: 2.688,
    cy: 2.688,
    r: 2.688,
    transform: "translate(3.242 5.209)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M5.388,9.153a2.182,2.182,0,1,1-.128,2.527",
    transform: "translate(-1.172 -2.607)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_199-2",
    "data-name": "Ellipse_199",
    transform: "translate(9.183 2.856)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 2.016,
    cy: 2.016,
    r: 2.016,
    transform: "translate(0 0)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    cx: 1.512,
    cy: 1.512,
    r: 1.512,
    transform: "translate(0.504 0.504)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_201-2",
    "data-name": "Ellipse_201",
    transform: "translate(9.183 8.905)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    cx: 2.016,
    cy: 2.016,
    r: 2.016,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#165cf3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_203",
    "data-name": "Ellipse 203",
    cx: 1.512,
    cy: 1.512,
    r: 1.512,
    transform: "translate(0.504 0.504)",
    fill: "none",
    stroke: "#165cf3",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_200-2",
    "data-name": "Ellipse_200",
    transform: "translate(3.734 11.896)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 2.016,
    cy: 2.016,
    r: 2.016,
    transform: "translate(0 0)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    "data-name": "Ellipse 205",
    cx: 1.512,
    cy: 1.512,
    r: 1.512,
    transform: "translate(0.504 0.504)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_135",
    "data-name": "Line 135",
    y2: 1.68,
    transform: "translate(5.93 4.033)",
    fill: "none",
    stroke: "#165cf3",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_136",
    "data-name": "Line 136",
    y2: 1.68,
    transform: "translate(5.93 10.082)",
    fill: "none",
    stroke: "#165cf3",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_137",
    "data-name": "Line 137",
    x1: 1.391,
    y2: 0.941,
    transform: "translate(7.792 5.867)",
    fill: "none",
    stroke: "#165cf3",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_138",
    "data-name": "Line 138",
    x2: 1.391,
    y2: 0.941,
    transform: "translate(7.792 8.912)",
    fill: "none",
    stroke: "#165cf3",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    cx: 0.383,
    cy: 0.383,
    r: 0.383,
    transform: "translate(3.363 7.514)",
    fill: "#165cf3"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1345",
    "data-name": "Rectangle 1345",
    width: 18,
    height: 18,
    transform: "translate(176 320)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKafkaDarkIcon);
export default __webpack_public_path__ + "static/media/kafka-dark-icon.beb278ecde46bed4ea13a53505fffaea.svg";
export { ForwardRef as ReactComponent };